export const environment = {
  production: false,
  apiPath: 'https://staging.adminv2.talentlitmus.com',
  apiPathV1: 'https://staging.talentlitmus.com/api',
  env: 'staging',
};
